import React from 'react';
import MaturityIndex from '../components/MaturityIndex';
import Pageheader from '../utils/headerHelment';

const MaturityIndexPage = () => {
    return (
        <>
            <Pageheader title="LENS - Maturity Index" />
            <MaturityIndex />
        </>
    );
};

export default MaturityIndexPage;
